export default __webpack_public_path__ + "static/media/square-purple-1.2ccf4a89.png";